import BlogIcon from 'components/Brand/Icons/Toolbox/NavBar/BlogIcon';
import WebinarIcon from 'components/Brand/Icons/Toolbox/NavBar/WebinarIcon';
import PodcastIcon from 'components/Brand/Icons/Toolbox/NavBar/PodcastIcon';
import ToolsIcon from 'components/Brand/Icons/Toolbox/NavBar/ToolsIcon';
import ToolboxHome from 'components/Brand/Icons/Toolbox/NavBar/ToolboxHome';
import GrownthSeriesIcon from 'components/Brand/Icons/Toolbox/NavBar/GrowthSeriesIcon';
import PlaybookIcon from 'components/Brand/Icons/Toolbox/NavBar/PlaybookIcon';
import GuidesIcon from 'components/Brand/Icons/Toolbox/NavBar/GuidesIcon';
import UserIcon from 'components/Brand/Icons/Toolbox/NavBar/UserIcon';

const toolboxDetailSubNav = () => {
  return {
    logo: {
      Icon: ToolboxHome,
      alt: 'Toolbox Logo',
      slug: '/toolbox',
    },
    user: {
      Icon: UserIcon,
      alt: 'User',
    },
    navigation: [
      {
        icon: BlogIcon,
        slug: '/blog',
        title: 'Blog',
      },
      {
        icon: WebinarIcon,
        slug: '/webinar',
        title: 'Webinars',
      },
      {
        icon: PodcastIcon,
        slug: '/podcasts',
        title: 'Podcasts',
      },
      {
        icon: ToolsIcon,
        slug: '/tools',
        title: 'Tools',
      },
      {
        icon: GuidesIcon,
        slug: '/guides',
        title: 'Guides',
      },
      {
        icon: PlaybookIcon,
        slug: '/field-service-management',
        title: 'Playbook',
      },
      {
        icon: GrownthSeriesIcon,
        slug: '/webinar/growth-series',
        title: 'Growth Series',
      },
    ],
  };
};

export default toolboxDetailSubNav;
